export enum DeleteDialogText {
    SINGLE_ACC_HEADER = 'Delete Selected Account',
    MULTIPLE_ACC_HEADER = 'Delete Selected Accounts',
    ALL_ACC_HEADER = 'Delete Accounts for All years',
    MULTIPLE_ACC_PARA_1 = "Deleting this items may cause the Trial Balance to be out of balance.",
    SINGLE_ACC_PARA_1 = "Deleting this item may cause the Trial Balance to be out of balance.",
    SINGLE_ACC_PARA_2 = "Additionally, following items associated with the selected account will also be deleted.",
    SINGLE_ACC_CONFIRMATION = "If you still wish to proceed, please enter ‘Delete Account’ below",
    MULTIPLE_ALL_ACC_PARA_2 = "Additionally, following items associated with the selected accounts will also be deleted.",
    MULTIPLE_ACC_CONFIRMATION = "If you still wish to proceed, please enter ‘Delete Accounts’ below",
    ALL_ACC_PARA_1 = "This action will permanently remove all entries, also documents including financial statement.",
    ALL_ACC_CONFIRMATION = "If you still wish to proceed, please enter ‘Delete All' below",
    CONFIRMATION_LINE = "Are you sure you want to delete?",
    SINGLE_ACC_PLACEHOLDER = 'Delete Account' ,
    MULTIPLE_ACC_PLACEHOLDER = 'Delete Accounts',
    ALL_ACC_PLACEHOLDER = 'Delete All',
}

